import React from 'react';
import Container from '../layout/Container';
import Eyebrow from '../ui/Eyebrow';
import SectionHeading from '../ui/SectionHeading';
import { colors, font } from '../../lib/tokens';

const STEPS = [
  {
    n: '01',
    title: 'The clinician writes.',
    body: 'Physicians document as usual, inside the hospital EHR. No new workflow, no copy-paste.',
  },
  {
    n: '02',
    title: 'KatlaCode reads.',
    body: 'Our clinical NLP parses the note in real time and ranks ICD-10 candidates by confidence.',
  },
  {
    n: '03',
    title: 'One click to confirm.',
    body: 'The clinician confirms, and the code is pushed to the patient record, fully audited.',
  },
];

export default function ProductShowcaseSection() {
  return (
    <section
      id="product"
      className="kc-section"
      style={{
        background: colors.bg,
        borderTop: `1px solid ${colors.hair}`,
      }}
    >
      <Container>
        <div data-reveal>
          <Eyebrow>How it works</Eyebrow>
          <SectionHeading style={{ marginBottom: 64, maxWidth: 720 }}>
            Three steps. Zero friction
            {' '}<br />
            for the clinician.
          </SectionHeading>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-reveal
              className="kc-rule"
              style={{ '--d': `${i * 90}ms`, paddingTop: 20 } as React.CSSProperties}
            >
              <div style={{ fontFamily: font.mono, fontSize: 11, color: colors.blue, letterSpacing: 1 }}>
                STEP {s.n}
              </div>
              <h3
                style={{
                  fontFamily: font.sans,
                  fontSize: 24,
                  fontWeight: 500,
                  letterSpacing: -0.5,
                  marginTop: 18,
                  marginBottom: 12,
                  color: colors.ink,
                }}
              >
                {s.title}
              </h3>
              <p
                style={{
                  color: colors.muted,
                  fontSize: 15,
                  lineHeight: 1.65,
                  margin: 0,
                }}
              >
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
